import React from 'react';
import { FaFacebook, FaHeart, FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-10">
  <div className="container mx-auto px-4">
    <div className="flex flex-wrap pt-12">
      
      {/* Our Offerings */}
      <div className="w-full sm:w-1/2 lg:w-1/4 mb-8">
        <div>
          <h6 className="uppercase mb-5 font-semibold text-White hover:text-[#6cbb23]">Our Offerings</h6>
          <ul className="space-y-2 text-gray-400">
            <li><a className="hover:text-[#6cbb23]">Digital Menu</a></li>
            <li><a  className="hover:text-[#6cbb23]">Order Placing</a></li>
            <li><a  className="hover:text-[#6cbb23]">Personalize Marketing</a></li>
          </ul>
        </div>
      </div>

      {/* Navigation */}
      <div className="w-full sm:w-1/2 lg:w-1/4 mb-8">
        <div>
          <h6 className="uppercase mb-5 font-semibold  hover:text-[#6cbb23]">Navigation</h6>
          <ul className="space-y-2 text-gray-400">
            <li><a  className="hover:text-[#6cbb23]">Home</a></li>
            <li><a href="/login" className="hover:text-[#6cbb23]">Login</a></li>
            <li><a className="hover:text-[#6cbb23]">Book a Demo</a></li>
          </ul>
        </div>
      </div>

      {/* Benefits */}
      <div className="w-full sm:w-1/2 lg:w-1/4 mb-8">
        <div>
          <h6 className="uppercase mb-5 font-semibold  hover:text-[#6cbb23]">Benefits</h6>
          <ul className="space-y-2 text-gray-400">
            <li><a  className="hover:text-[#6cbb23]">Run Promotions</a></li>
            <li><a  className="hover:text-[#6cbb23]">Increase Sales</a></li>
            <li><a  className="hover:text-[#6cbb23]">Reduce Cost & Time</a></li>
          </ul>
        </div>
      </div>

      {/* Quick About */}
      <div className="w-full sm:w-1/2 lg:w-1/4 mb-8">
        <div>
          <h6 className="uppercase mb-5 font-semibold  hover:text-[#6cbb23]">Quick About</h6>
          <p className="text-gray-400 mb-3 hover:text-[#6cbb23]">
            We help you to provide great experience to your customer and increase your sales.
          </p>
          <p className=" mb-4 text-gray-400 hover:text-[#6cbb23]">
            +91 80 975 88099 <br />
            info@zafflo.com
          </p>
          <div className="flex space-x-4  ">
            <a target="_blank" href="https://www.facebook.com/zafflo"><i className="bg-[#6cbb23]" /><FaFacebook/></a>           
            <a target="_blank" href="https://www.linkedin.com/company/zafflo/?viewAsMember=true"><i className="fa fa-linkedin" /><FaLinkedin/></a>
            <a target="_blank" href="https://www.instagram.com/_zafflo/"><i className="fa fa-linkedin" /><FaInstagram/></a>
          </div>
        </div>
      </div>
    </div>

    {/* Footer Bottom */}
    <div className="border-t pt-6 mt-6 flex flex-wrap justify-between items-center text-sm ">
      <p className="m-0">
        &copy; {new Date().getFullYear()} All rights reserved | This business & website is made
        <i className="fa fa-heart-o text-red-500" aria-hidden="true" /> by{' '}
        <a href="https://zafflo.com" target="_blank" rel="noreferrer" className="text-[#6cbb23] hover:underline">
        ZAFFLO
        </a>
      </p>
    </div>
  </div>
</footer>

  );
};

export default Footer;